import React, { useState, useEffect } from 'react';
import axios from 'axios';
import localStorage from '../../../utils/localStorage';
import { PlusOutlined, DeleteOutlined } from '@ant-design/icons';
import { Select, message, Input, TreeSelect, Button } from 'antd';
import { API_PARAMETER, API_STATUSMAPPING } from '../../../commons/api';

const { TreeNode } = TreeSelect;

const Condition = (props) => {
  const [deviceList, setDeviceList] = useState([]);
  const [parameterList, setParameterList] = useState([]);

  const {
    index,
    rowKey,
    ifCond,
    ifIndex,
    Operator,
    ifCondition,
    assetValue,
    assetType,
    HierarchyCode,
    onSelectChange,
    addNewCondition,
    deleteCondition,
  } = props;

  useEffect(() => {
    getDeviceList(assetValue, assetType, HierarchyCode);
  }, [assetValue, assetType, HierarchyCode]);

  const onDeviceChange = (deviceId) => {
    getParameterList(deviceId);
  };

  const getDeviceList = (assetValue, assetType, HierarchyCode) => {
    const siteId = localStorage.get('currentSite');
    const accessToken = localStorage.get('accessToken');
    const Object = {
      method: 'GET',
      url: `${API_STATUSMAPPING.GetDevicesList}?SiteId=${siteId}&Code=${assetValue}&Type=${assetType}&HierarchyCode=${HierarchyCode}`,
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    };
    return axios(Object)
      .then((response) => {
        setDeviceList(response.data);
      })
      .catch((err) => {
        if (err.response && err.response.status === 400) {
          message.info(err.response.data.message);
        }
      });
  };

  const getParameterList = (deviceAlias) => {
    const siteId = localStorage.get('currentSite');
    const accessToken = localStorage.get('accessToken');
    const Object = {
      method: 'GET',
      url: `${API_PARAMETER.LIST}?SiteId=${siteId}&DeviceAlias=${deviceAlias}`,
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    };
    return axios(Object)
      .then((response) => {
        let parameterList =
          response.data && Array.isArray(response.data)
            ? response.data.map((param) => ({
                label: param.ParameterCode,
                value: param.ParameterAlias,
              }))
            : [];
        setParameterList(parameterList);
      })
      .catch((err) => {
        if (err.response && err.response.status === 400) {
          message.info(err.response.data.message);
        }
      });
  };

  const handleSelectChange = (value, rowKey, ifIndex, key) => {
    if (key === 'Device') {
      onDeviceChange(value);
    }
    onSelectChange(value, rowKey, ifIndex, key);
  };

  const renderDeviceTreeNodes = (data) =>
    data &&
    Array.isArray(data) &&
    data.map((item) => {
      if (item.children) {
        return (
          <TreeNode value={item.Code} title={item.Name} key={item.Code} dataRef={item}>
            {renderDeviceTreeNodes(item.children)}
          </TreeNode>
        );
      }
      return <TreeNode value={item.Code} key={item.Code} title={item.Name} {...item} />;
    });

  return (
    <>
      <div style={{ margin: '10px' }} key={index}>
        {index === 0 ? <div style={{  marginBottom: '3px' }}>IF</div> : null}
        <TreeSelect
          showSearch
          style={{ width: 200, marginRight: '5px' }}
          value={ifCond.Device}
          dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
          placeholder={'Select Device'}
          allowClear={false}
          treeDefaultExpandAll
          onChange={(value) => {
            handleSelectChange(value, rowKey, ifIndex, 'Device');
          }}
        >
          {renderDeviceTreeNodes(deviceList)}
        </TreeSelect>

        <Select
          style={{ width: 170, marginRight: '5px' }}
          placeholder={'Select parameter'}
          value={ifCond.Parameter}
          onChange={(value) => handleSelectChange(value, rowKey, ifIndex, 'Parameter')}
          options={parameterList}
        />
        <Select
          style={{ width: 170, marginRight: '5px' }}
          placeholder={'Select operator'}
          value={ifCond.Operator}
          onChange={(value) => handleSelectChange(value, rowKey, ifIndex, 'Operator')}
          options={Operator}
        />
        <Input
          style={{ width: 170, marginRight: '5px' }}
          value={ifCond.Value}
          placeholder="Select value"
          onChange={(e) => handleSelectChange(e.target.value, rowKey, ifIndex, 'Value')}
        />
        {Object.keys(ifCondition)[Object.keys(ifCondition).length - 2] === rowKey ? (
          <>
            <Button type="primary" icon={<PlusOutlined />} onClick={() => addNewCondition(ifIndex)} />
          </>
        ) : null}
        {Object.keys(ifCondition)[Object.keys(ifCondition).length - 2] === rowKey &&
          Object.keys(ifCondition).length !== 2 ? (
          <>
            <Button
              style={{ marginLeft: '5px' }}
              type="danger"
              icon={<DeleteOutlined />}
              onClick={() => deleteCondition(ifIndex, rowKey)}
            />
          </>
        ) : null}
      </div>
    </>
  );
};

export default Condition;
